import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { setEnvironment } from '@yukawa/chain-base-angular-client';
import { environment } from './environments';
import { isDevMode } from '@angular/core';

setEnvironment(environment);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
